import { Component, OnInit } from '@angular/core';
import { Title, Meta } from "@angular/platform-browser";

import { EventsService, Event } from "../../services/events/events.service";

let $_: any;
declare var google: any;

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

    events: Event[] = [];
    db_read_complete: boolean = false;
    map_params = {lat: 43.088947, lng: -76.154480, zoom : 6, fit_bounds: false};

    constructor(private title_service: Title, private meta_service: Meta, private events_service: EventsService) {

        $_ = this;
        $_.title_service.setTitle('Sinirji 911 Live | Real-Time Web-based Access to Critical Incident Info');
    }

    ngOnInit() {

        $_.events_service.get_events('', (events) => {

            $_.events = events;
            $_.db_read_complete = true;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts